import React from 'react';
import ImageSlider from '/Foundation/React/code/Components/ImageSlider';

const getFirstVisibleAccordion = (product) => {
  if (product.TechSpecs?.length > 0) return 'specifications';
  if (product.Features?.length > 0) return 'features';
  if (product.Descriptions?.length > 0) return 'product-description';
  return null;
};

export const QuickViewPDP = ({ product }) => {
  if (!product) return;

  const expandedAccordion = getFirstVisibleAccordion(product);

  return (
    <div className="quick-view-pdp">
      <div className="content">
        <div className="product-left">
          <div>
            {product.ProductImages?.length > 0 && (
              <ImageSlider
                images={product.ProductImages.map((x) => {
                  return { src: x.ImageURL, alt: x.ImageAltText };
                })}
                enableThumbnailCarousel={false}
              />
            )}
          </div>
          <div>
            {product.Award && (
              <a
                className="quick-view-pdp__award"
                href={product.Award.AwardUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  title={product.Award.AwardDescriptionTooltip}
                  src={product.Award.AwardImageUrl}
                  alt={product.Award.AwardDescriptionTooltip}
                  loading="lazy"
                />
              </a>
            )}

            <h1 className={`heading3 ${product.Award ? '' : 'mt-7'}`}>{product.WebTitle1}</h1>
            <p className="paragraph quick-view-pdp--description">{product.ThuleProductHeading}</p>
          </div>
        </div>

        <div className="product-right">
          <div className="accordion_wrapper">
            <div className="accordion">
              {product.TechSpecs?.length > 0 && (
                <div className="accordion-item">
                  <h2 id="heading-specifications">
                    <button
                      className={`accordion-button${expandedAccordion === 'specifications' ? '' : ' collapsed'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-specifications"
                      aria-expanded={expandedAccordion === 'specifications'}
                      aria-controls="collapse-specifications"
                    >
                      <span className="heading4">{product.Translations.TechnicalSpecifications}</span>
                    </button>
                  </h2>

                  <div
                    id="collapse-specifications"
                    className={`accordion-collapse collapse${expandedAccordion === 'specifications' ? ' show' : ''}`}
                    aria-labelledby="heading-specifications"
                  >
                    <div className="accordion-body">
                      {product.TechSpecs.map((techSpec, index) => {
                        const links = techSpec.Links?.map((link, i) =>
                          link.LinkUrl ? (
                            <a key={i} href={link.LinkUrl}>
                              {link.LinkText}
                            </a>
                          ) : (
                            link.LinkText
                          )
                        );

                        return (
                          <div className="techSpecs__Item" key={index}>
                            <p className="heading6">{techSpec.Title}</p>

                            <p className="paragraph-small text-color--gray70">
                              {techSpec.Values?.length ? (
                                techSpec.Values.map((value, i) => (
                                  <span className="d-block" key={i}>
                                    {value}
                                  </span>
                                ))
                              ) : (
                                <span>
                                  {techSpec.Value} {techSpec.Unit}
                                  {links?.length > 0 && (
                                    <>
                                      <br />
                                      {links.map((link, i) => (
                                        <span key={i}>
                                          {link}
                                          {i < links.length - 1 && <br />}
                                        </span>
                                      ))}
                                    </>
                                  )}
                                  {techSpec.Icon && <i className={techSpec.Icon}></i>}
                                </span>
                              )}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {product.Features?.length > 0 && (
                <div className="accordion-item">
                  <h2 id="heading-features">
                    <button
                      className={`accordion-button${expandedAccordion === 'features' ? '' : ' collapsed'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-features"
                      aria-expanded={expandedAccordion === 'features'}
                      aria-controls="collapse-features"
                    >
                      <span className="heading4">{product.Translations.Features}</span>
                    </button>
                  </h2>

                  <div
                    id="collapse-features"
                    className={`accordion-collapse collapse${expandedAccordion === 'features' ? ' show' : ''}`}
                    aria-labelledby="heading-features"
                  >
                    <div className="accordion-body">
                      {product.Features.map((feature, i) => {
                        return (
                          <div key={i} className="mb-4 feature-text-content">
                            <h3 className="heading5">{feature.FeatureHeading}</h3>
                            <p className="paragraph">{feature.FeatureShortDescription}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {product.Descriptions?.length > 0 && (
                <div className="accordion-item">
                  <h2 id="heading-product-description">
                    <button
                      className={`accordion-button${expandedAccordion === 'product-description' ? '' : ' collapsed'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-product-description"
                      aria-expanded={expandedAccordion === 'product-description'}
                      aria-controls="collapse-product-description"
                    >
                      <span className="heading4">{product.Translations.ProductDescription}</span>
                    </button>
                  </h2>

                  <div
                    id="collapse-product-description"
                    className={`accordion-collapse collapse${expandedAccordion === 'product-description' ? ' show' : ''}`}
                    aria-labelledby="heading-product-description"
                  >
                    <div className="accordion-body">
                      {product.Descriptions.map((description, i) => {
                        return (
                          <div key={i} className="mb-6">
                            {description.DescriptionHeader && (
                              <h5 className="heading5 mb-4">{description.DescriptionHeader}</h5>
                            )}
                            {description.DescriptionBody && <p className="paragraph">{description.DescriptionBody}</p>}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="quick-view-pdp__footer d-flex d-lg-none">
          <a className="product-link mb-6" href={product.Url}>
            {product.Translations.VisitProductPage}
          </a>
        </div>
      </div>
      <div className="quick-view-pdp__footer d-none d-lg-flex">
        <a className="product-link" href={product.Url}>
          {product.Translations.VisitProductPage}
        </a>
      </div>
    </div>
  );
};
